import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ad2f1e2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistics-cards" }
const _hoisted_2 = { class: "stat-card" }
const _hoisted_3 = { class: "stat-card-top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-card-title-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stat-card-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-wallet" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Итоговая сумма")
], -1))
const _hoisted_5 = { class: "pi pi-info-circle stat-info-icon" }
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "stat-value-rubles" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stat-value-separator" }, ".", -1))
const _hoisted_9 = { class: "stat-value-kopeks" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "currency-symbol" }, "₽", -1))
const _hoisted_11 = { class: "stat-card" }
const _hoisted_12 = { class: "stat-card-top" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-card-title-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stat-card-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Количество пользователей")
], -1))
const _hoisted_14 = { class: "pi pi-info-circle stat-info-icon" }
const _hoisted_15 = { class: "stat-value" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "stat-card" }
const _hoisted_18 = { class: "stat-card-top" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-card-title-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stat-card-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-database" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Количество сегментов")
], -1))
const _hoisted_20 = { class: "pi pi-info-circle stat-info-icon" }
const _hoisted_21 = { class: "stat-value" }
const _hoisted_22 = { key: 1 }

import { formatNumber } from "@/services/utils/Strings";
import Skeleton from "primevue/skeleton";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticsCards',
  props: {
    statistics: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



const formatCostRubles = (costInKopeks: number): string => {
  const rubles = Math.floor(costInKopeks / 100);
  return formatNumber(rubles);
};

const formatCostKopeks = (costInKopeks: number): string => {
  const kopeks = costInKopeks % 100;
  return kopeks.toString().padStart(2, "0");
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("i", _hoisted_5, null, 512), [
          [
            _directive_tooltip,
            {
            value: 'Общая сумма расходов по всем кампаниям и сегментам',
            class: 'white-tooltip-with-arrow',
          },
            void 0,
            { bottom: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeleton), {
              key: 0,
              width: "180px",
              height: "2rem",
              class: "stat-value-skeleton"
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(formatCostRubles(_ctx.statistics.total_cost)), 1),
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(formatCostKopeks(_ctx.statistics.total_cost)), 1),
              _hoisted_10
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("i", _hoisted_14, null, 512), [
          [
            _directive_tooltip,
            {
            value:
              'Общее количество пользователей во всех сегментах (из счётчика сегментов)',
            class: 'white-tooltip-with-arrow',
          },
            void 0,
            { bottom: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeleton), {
              key: 0,
              width: "150px",
              height: "2rem",
              class: "stat-value-skeleton"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(formatNumber)(_ctx.statistics.total_users)), 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _withDirectives(_createElementVNode("i", _hoisted_20, null, 512), [
          [
            _directive_tooltip,
            {
            value: 'Общее количество сегментов в статистике',
            class: 'white-tooltip-with-arrow',
          },
            void 0,
            { bottom: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeleton), {
              key: 0,
              width: "80px",
              height: "2rem",
              class: "stat-value-skeleton"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(formatNumber)(_ctx.statistics.segments_count)), 1))
      ])
    ])
  ]))
}
}

})